import React, { useState, useRef } from 'react';
import 'katex/dist/katex.min.css';
import katex from 'katex';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { fetchOCR } from '../../api/demonstration';
import FunctionDemonstration from './FunctionDemonstration';
import account from '@/common/account/index';

const OcrGSDemonstration = ({ materialsPath, selectList }) => {
  const refResultEle = useRef(null);
  const [result, setResult] = useState({});
  const [response, setReponse] = useState(null);
  const [request] = useState({
    Params: {
      picture: '图片的Base64编码',
      url: '图像地址'
    }
  });

  const identifyingImg = (imgUrl, picture) => {
    let imgBase64 = null;
    if (picture) {
      imgBase64 = picture.replace(/\S*base64,/, '');
    }
    const imgUrlArr = imgUrl ? [imgUrl] : '';
    const imgBase64Arr = imgBase64 ? [imgBase64] : '';
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    fetchOCR({
      image_url: imgUrlArr,
      image_base64: imgBase64Arr || undefined,
      method: '/aiimage/common-formula-reg',
      type: 0,
      reg_flag: 0,
      userId
    })
      .then((data) => {
        setReponse(data);
        if (data.code === 20000) {
          const res = data.data[0];
          setResult(res);
          katex.render(res.formula_result || '', refResultEle.current, {
            throwOnError: false,
            errorColor: '#042044',
            strict: 'ignore'
          });
        }
      })
      .catch((err) => {
        Message.error(err.msg || err.message);
        setReponse({});
      });
  };

  return (
    <FunctionDemonstration
      result={<ul>{<li key={result.formula_result} ref={refResultEle} />}</ul>}
      response={response}
      request={request}
      handleIdentifyingImg={identifyingImg}
      materialsPath={materialsPath}
      selectList={selectList}
    />
  );
};

OcrGSDemonstration.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array
  })
};

export default OcrGSDemonstration;
